import { render } from "./b-card.vue?vue&type=template&id=58eafa0d"
import script from "./b-card.vue?vue&type=script&lang=js"
export * from "./b-card.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__